import { render, staticRenderFns } from "./Conquest.vue?vue&type=template&id=6b4913c0&scoped=true&"
import script from "./Conquest.vue?vue&type=script&lang=ts&"
export * from "./Conquest.vue?vue&type=script&lang=ts&"
import style0 from "./Conquest.vue?vue&type=style&index=0&id=6b4913c0&prod&lang=css&"
import style2 from "./Conquest.vue?vue&type=style&index=2&id=6b4913c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4913c0",
  null
  
)

export default component.exports